export default [{
  path: '/cms/:site/',
  name: 'cms.home',
  component: () => import('@/views/admin/Index.vue'),
  children: [{
      path: 'category',
      name: 'cms.category',
      component: () => import('@/views/cms/category/Index.vue')
    },
    {
      path: 'article',
      name: 'cms.article',
      component: () => import('@/views/cms/article/Index.vue'),
    },
    {
      path: 'article/edit/:article?',
      name: 'cms.article.edit',
      meta: {
        name: '编辑文章'
      },
      component: () => import('@/views/cms/article/Editor.vue')
    },
    {
      path: 'video',
      name: 'cms.video',
      component: () => import('@/views/cms/video/Index.vue')
    },
    {
      path: 'page',
      name: 'cms.page',
      component: () => import('@/views/cms/page/Index.vue')
    },
    {
      path: 'media/:directory?',
      name: 'cms.media',
      meta: {
        name: '素材管理'
      },
      component: () => import('@/views/cms/media/Index.vue')
    }
  ]
}]


// WEBPACK FOOTER //
// ./src/router/modules/cms.js